import React, { useEffect } from "react";
import Title from "./Components/Title";
import DefaultLayout from "../Containers/Layout/DefaultLayout";

const AlbumListeningEvent = () => {
  var album = "https://streams.radiomast.io/station/458cb1fa-5d67-4e84-9272-5fae8812546b/player/widget?t=dark&s=8ebd33a7-592c-4eba-8049-25b0a10038cc";
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//rumbletalk.com/client/?B_aLnmdZ"
    );
    document.body.appendChild(addScript);
  }, []);
  return (
    <div className="page sonos">
      <Title value="Album Listening Event" />
      <DefaultLayout
        disablePlayer
        disableBanner
        disableNavItems
      >
      <main className="event-lander">
        <section className="flex-container">
          <div className="column" id="rumble-container" style={{ height: "600px"}}><div id="rt-2ce7eea6437e4f137a65ba95f2b41672"></div></div>
          <div className="column">
            <iframe title="radiomast-player" src={album} scrolling="no" frameBorder="0" allow="autoplay" style={{ margin: "50% 40%"}}></iframe>
          </div>
        </section>
      </main>
      </DefaultLayout>
    </div>
  );
};

export default AlbumListeningEvent;
